import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { CONSTANTS } from '@app/constants';

import { PlayerEvents } from './player.service';


@Injectable({
  providedIn: 'root'
})
export class YTService {

	private Player: any;
	private embedded: boolean = false;
	private renderer: Renderer2;
	private tryLoadScript: number = 0;

	constructor(
		@Inject(DOCUMENT) private _document:any,
		private playerEvents: PlayerEvents,
		private rendererFactory: RendererFactory2
	) {
		// Get an instance of Renderer2
    this.renderer = this.rendererFactory.createRenderer(null, null);

	}

	/* AGNOSTIC PLAYER EVENTS */

	private playerEvent = (event: string) => {
		this.playerEvents.playerEvent(event);
	}

	/* CONTROLL */

	public playVideo = (): void => {
		console.log('**** YTService playVideo this.Player ', this.Player);
		this.Player.playVideo();
	}

	public pauseVideo = (): void => {
		console.log('**** YTService pauseVideo this.Player ', this.Player);
		this.Player.pauseVideo();
	}

	/* LOAD SCRIPT */

	public loadScript = (medium: any) => {

		if (!this.embedded) {
			const s = this.renderer.createElement('script');
			s.type = 'text/javascript';
			s.src = 'https://www.youtube.com/iframe_api';
			s.text = ``;

			this.renderer.appendChild(this._document.body, s);
			s.onload = this.onScriptLoad(medium);

			this.embedded = true;
		}
		else {
			this.loadVideo(medium);
		}
		
	}

	private onScriptLoad = (medium: any) => {
    console.log('**** YTService onScriptLoad medium ', medium);

    setTimeout(
    	() => {
    		
    		console.log('**** YTService onScriptLoad medium ', medium);

    		this.loadVideo(medium);
    	},
    	100
    );
  }

	/*  PLAYER YT API */

	public loadVideo(medium:any) {
	  console.log('YTService loadVideo medium',  medium);
	  console.log('YTService loadVideo (window as any)[YT]',  (window as any)['YT']);

		//this.medium = medium;
	  //this.reframed = false;

	  if ((window as any)['YT']) {

	  	const uid = medium.playerName + medium.id + medium.provider;

	  	this.Player = new (window as any)['YT'].Player(uid, {
		    width: '100%',
		    height: '100%',
		    videoId: medium.id,
		    playerVars: {
		      autoplay: 0,
		      modestbranding: 0,
		      color: 'white',
		      controls: 1,
		      disablekb: 0,
		      rel: 0,
		      showinfo: 0,
		      fs: 1,
		      playsinline: 1,
		      wmode: 'transparent',
		      enablejsapi: 1,
		      origin: CONSTANTS.baseUrl
		    },
		    events: {
		      'onStateChange': this.onPlayerStateChange.bind(this),
		      'onError': this.onPlayerError.bind(this),
		      'onReady': this.onPlayerReady.bind(this),
		    }
		  });
	  }
	  else if (this.tryLoadScript <= 10) {
	  	this.tryLoadScript++;
	  	this.onScriptLoad(medium);
	  }
	}

	private onPlayerReady(event:any) {
	  console.log('onPlayerReady PlayerComponent',  event);

	  this.playerEvent('loaded');

	  event.target.playVideo();

	  /*if (this.isRestricted) {
	    event.target.mute();
	    event.target.playVideo();
	  } else {
	    event.target.playVideo();
	  }*/
	}

	private onPlayerStateChange(event:any) {
	  console.log(event);
	  switch (event.data) {
	    case (window as any)['YT'].PlayerState.PLAYING:
	      if (this.cleanTime() == 0) {
	    //console.log('started ' + this.cleanTime());
	      } else {
	    //console.log('playing ' + this.cleanTime());
	      }

	      //this.PlayerPlaying();

	      this.playerEvent('play');

	      break;
	    case (window as any)['YT'].PlayerState.PAUSED:
	      if (this.Player.getDuration() - this.Player.getCurrentTime() != 0) {
	    //console.log('paused' + ' @ ' + this.cleanTime());
	      };

	      //this.PlayerStopped();

	      this.playerEvent('pause');
	      
	      break;
	    case (window as any)['YT'].PlayerState.ENDED:
	  //console.log('ended ');

	      //this.PlayerStopped();

	      this.playerEvent('pause');

	      break;
	  }
	}

	private	cleanTime() {
	  return Math.round(this.Player.getCurrentTime())
	}

	private	onPlayerError(event:any) {
	  console.log('YTService onPlayerError event',  event);

	  this.playerEvent('error');

	  //this.PlayerStopped();

	  switch (event.data) {
	    case 2:
	  //console.log('' + this.video)
	      break;
	    case 100:
	      break;
	    case 101 || 150:
	      break;
	  }
	}
}